export default __webpack_public_path__ + "static/media/p32.3916c474.jpg";